import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { Modals } from '@/constants';
import { EVENT_CONSTANTS } from '@/services';
import {
  selectSessionIsLoading,
  selectSessionUserId,
  uiActions,
  useAppDispatch,
  useAppSelector,
  useFetchMarketingSignupPromptInfoQuery,
} from '@/store';

const DEFAULT_DELAY_MS = 100;
const MARKETING_PARAM = 'modal';
const PARAM_VALUE = 'trial_group';

export const useDelayedSignupPrompt = (episodeId?: string) => {
  const dispatch = useAppDispatch();

  const isSessionLoading = useAppSelector(selectSessionIsLoading);
  const userId = useAppSelector(selectSessionUserId);
  const { data: marketingInfo, isLoading: isMarketingInfoLoading } =
    useFetchMarketingSignupPromptInfoQuery();

  const [searchParams] = useSearchParams();
  const isMarketingVisit = searchParams.get(MARKETING_PARAM) === PARAM_VALUE;

  useEffect(() => {
    if (
      !isMarketingVisit ||
      isSessionLoading ||
      isMarketingInfoLoading ||
      userId
    )
      return;

    const timeout = setTimeout(() => {
      dispatch(
        uiActions.setActiveModal({
          name: Modals.SIGN_UP,
          params: {
            episodeId,
            isMarketingModal: true,
            referrer: {
              component: EVENT_CONSTANTS.COMPONENT.DELAYED_SIGNUP_PROMPT,
            },
          },
        }),
      );
    }, marketingInfo?.delayMs ?? DEFAULT_DELAY_MS);

    return () => clearTimeout(timeout);
  }, [
    dispatch,
    userId,
    episodeId,
    isSessionLoading,
    isMarketingInfoLoading,
    isMarketingVisit,
    marketingInfo,
  ]);
};
